<template>
	<v-container fluid class="pt-0">
		<v-expansion-panels flat>
			<v-expansion-panel style="border: 1px solid #185EA91A; background-color: #E7EEF6;">
				<v-expansion-panel-header>
					<span style="font-size: 16px; color: black;" class="font-weight-bold">{{ $t('wkt.admin.license.upgrade-account-window.voucher.title') }}</span>
				</v-expansion-panel-header>
				<v-expansion-panel-content>					
					<v-form ref="form">
                        <v-row class="pa-0">
							<v-col cols="4" md="5" sm="8" class="mx-auto d-flex justify-center alig-center">                
								<v-text-field
								v-model="code"
								:label="$t('wkt.admin.license.upgrade-account-window.voucher.description')"
								autocomplete="none"
								:error-messages="errorMessages"
								:disabled="disableTextField"
								/>      
								<v-btn color="#185EA9" class="white--text" :disabled="disableRedeemButton" @click="onOk()" style="font-size: 0.9em; font-weight: 400;">{{ 'canjear'/*$t('wkt.admin.license.upgrade-account-window.voucher.redeem').toUpperCase()*/ }}</v-btn>
							</v-col>								
                        </v-row>                    
					</v-form>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-container>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import api from '../../../../api/worktime.js';

export default {
    name: 'AddVoucher',
    mixins: [BaseModule],	
	components: {
	},
    data () {
		return {
			code: '',
			msgCb: null,
			errorMessages: [],
			currentVoucher: null,
		}
    },
	mounted() {
		if (this.$refs.form) {
			this.$refs.form.reset();
			this.$refs.form.resetValidation();
		}

        this.errorMessages = [];
	},
	computed: {
		disableTextField() {
			if (this.currentVoucher) {
				return true;
			}
			return false;
		},
		disableRedeemButton() {
			if (this.currentVoucher) {
				return true;
			}
			return this.code.trim().length === 0;
		}
	},
    methods: {
		onOk() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.loading = true;

			const application = {
				voucherCode: this.code
			};

			api.validateVoucher(application,
				data => {
					this.loading = false;

					if (!data) {
						this.errorMessages = [ this.$t('wkt.admin.license.invalid_voucher') ];
						return;
					}

					this.errorMessages = [];
					
					this.currentVoucher = data;
					this.$emit('voucher-used', data);
				},
				error => {
					this.loading = false;
					this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
				}
			);
		}, 
    },
}
</script>